import SeoHead from '@atoms/SeoHead';
import { getAllCategories } from '@lib/sanity';
import Layout from '@molecules/Layout';
import type { LayoutProps } from '@molecules/Layout/Layout.types';
import { getClient } from '@sanity/lib/getClient';
import TagsListPageView from '@views/TagsListPageView';
import type { TagsListPageViewProps } from '@views/TagsListPageView/TagsListPageView.types';
import type { GetStaticProps } from 'next';
import type { ReactElement } from 'react';

import { mapLayout } from '@/mappers/layout';
import { mapTagsList } from '@/mappers/tagsList';

interface TagsListProps {
  layoutData: Omit<LayoutProps, 'children'>;
  tagsListData: TagsListPageViewProps;
}

const TagsList = ({
  tagsListData,
  layoutData,
}: TagsListProps): ReactElement => (
  <>
    <SeoHead
      title="✈ Wszystkie kierunki"
      metaDescription="Przeglądaj wszystkie kierunki podróży. Wybierz miejsce, które Cię interesuje, żeby zobaczyć posty na jego temat. Chcesz zorganizować podróż? Przejdź do sekcji Poradnik."
    />
    <Layout {...layoutData}>
      <TagsListPageView {...tagsListData} />
    </Layout>
  </>
);

export const getStaticProps: GetStaticProps<TagsListProps> = async () => {
  const client = getClient();

  const categories = await getAllCategories(client);

  const tagsListData = mapTagsList(categories);
  const layoutData = mapLayout(categories);

  return {
    props: {
      tagsListData,
      layoutData,
    },
  };
};

export default TagsList;
